import { addDays, format } from 'date-fns'

import type { CSVLine } from './validators'

export const constructCsvTemplate = (): CSVLine[] => {
  const tomorrow = addDays(new Date(), 1)

  return [
    {
      Text: 'A post with text',
      'Image URL': undefined,
      Tags: undefined,
      'Posting Time': `${format(tomorrow, 'yyyy-MM-dd')} 17:30`,
    },
    {
      Text: 'A post with text and an image',
      'Image URL':
        'https://images.unsplash.com/photo-1745848413099-13adc3aaf308',
      Tags: undefined,
      'Posting Time': undefined,
    },
    {
      Text: 'A post with text and tags - must be existing tags',
      'Image URL': undefined,
      Tags: 'tag1,tag2',
      'Posting Time': undefined,
    },
  ]
}
